module.exports = __webpack_public_path__ + "img/closeSwiper.a4a1d3e1.svg";